import { useMutation, useQueryClient } from "@tanstack/react-query"
import { classes } from  '@shared/api/services'

export const useCancelOrder = () => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: (data) => classes.cancelOrder(data),
		onSuccess: () => {
      queryClient.invalidateQueries(['orders'])
    },
	})

	return mutation
}